/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plusonesfeature2Inputs */

const en_plusonesfeature2 = /** @type {(inputs: Plusonesfeature2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allow plus-ones`)
};

const de_plusonesfeature2 = /** @type {(inputs: Plusonesfeature2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Begleitung erlauben`)
};

/**
* | output |
* | --- |
* | "Allow plus-ones" |
*
* @param {Plusonesfeature2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const plusonesfeature2 = /** @type {((inputs?: Plusonesfeature2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plusonesfeature2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_plusonesfeature2(inputs)
	return de_plusonesfeature2(inputs)
});
export { plusonesfeature2 as "plusOnesFeature" }